/**
 * Created: 2026-10-29
 * Initial commit: Super admins refund an entitlement's remaining hours
 *
 * Course entitlement rules shared by the web admin and the mini program.
 */

import type { CourseEntitlementStatus } from '../labels'

interface EntitlementHours {
  status: CourseEntitlementStatus
  totalHours: number
  consumedHours: number
}

/**
 * Hours left on an entitlement. A CANCELLED entitlement keeps `totalHours`
 * as bought, but its unused hours were refunded, so none are left.
 */
export function remainingHoursOf(entitlement: EntitlementHours): number {
  if (entitlement.status === 'CANCELLED') return 0
  return Math.max(0, entitlement.totalHours - entitlement.consumedHours)
}
